module.exports = __webpack_public_path__ + "static/media/search_window.bf1326bb.svg";